import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const copyLinkTemplate = htmlE`
  <textarea id="copyLinkTextArea" class="textarea w-full" rows="3"></textarea>
`;

export default copyLinkTemplate;
